import React, { useEffect, useState } from "react";

import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import Select from "react-select";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../utils/IDS";
import {
  GetSingle,
  Update,
  Create,
  GetAll,
} from "../../../../features/admin/broadcast/broadcast/Slice";
import { useDispatch } from "react-redux";
import classNames from "classnames";
import { useForm } from "react-hook-form";
import Successfull_Modal from "../../../common-components/common_Modal/Successfull_Modal/Successfull_Modal";

const Add = ({ id, setId, setShowError, setSuccess, setErr, showError }) => {
  const [modalShow, setModalShow] = React.useState(false);
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    clearErrors,
    setValue,
    getValues,
    setError,
    control,
    watch,
    formState: { errors },
    reset,
  } = useForm();

  const GetData = async (id) => {
    try {
      const res = await dispatch(GetSingle(id));
      if (res.meta.requestStatus === "fulfilled") {
        reset(res?.payload?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (id !== "") {
      GetData(id);
    }
  }, [id]);

  const onSubmit = async (data) => {
    try {

      if(id){
        data.id = id;
      }
      let response;

      response = await dispatch(Create(data));



      console.log("response", response);

      if (response.payload.data) {
        if (response.payload.data.success) {
          await dispatch(GetAll());
          await setId("");
          setSuccess(true);
          setModalShow(true);
          reset({ name: "" });
          setShowError("");
          setTimeout(() => {
            setSuccess(false);
            setModalShow(false);
          }, 3000);
        } else {
          setShowError(response.payload?.response?.data?.message);
        }
      } else {
        setShowError(response.payload?.response?.data?.message);
      }
    } catch (error) {
      setErr(true);
      console.error("error in Add Faq", error);
    }
  };
  return (
    <>
      <div className="forms_section">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            <div className="col-lg-6 col-md-6 mb-3">
              <Form.Group
                className="form-field mb-3"
                controlId="formBasicEmail"
              >
                <Form.Label> Users</Form.Label>
                <Form.Select
                  title="User Type"
                  className={classNames("", {
                    "is-invalid": errors?.userType,
                  })}
                  {...register("userType", {
                    required: "Please select a user type",
                  })}
                >
                  <option value="">-- Select User Type --</option>
                  <option value="Customer">Customer</option>
                  <option value="Cab">Cab <sub>(Driver)</sub></option>
                  <option value="Transport">Transport <sub>(Driver)</sub></option>
                  <option value="all">All Users</option>
                  <option value="alldriver">All Drivers</option>
                </Form.Select>

                {errors.userType && (
                  <span className="text-danger">{errors.userType.message}</span>
                )}
              </Form.Group>
              <Form.Group
                className="form-field mb-3"
                controlId="formBasicEmail"
              >
                <Form.Label> Title</Form.Label>
                <Form.Control
                  type="text"
                  title="title"
                  placeholder="title"
                  className={classNames("", {
                    "is-invalid": errors?.title,
                  })}
                  {...register("title", {
                    required: "Title is required",
                    maxLength: {
                      value: 100,
                      message: "Title cannot exceed 100 characters",
                    },
                  })}
                />
                {errors.title && (
                  <span className="text-danger">{errors.title.message}</span>
                )}
                {showError && (
                  <Form.Text className="text-danger">{showError}</Form.Text>
                )}
              </Form.Group>

              <Form.Group
                className="form-field mb-3"
                controlId="formBasicEmail"
              >
                <Form.Label> Message</Form.Label>
                <Form.Control
                  as="textarea"
                  type="text"
                  title="message"
                  placeholder="message"
                  className={classNames("", {
                    "is-invalid": errors?.description,
                  })}
                  {...register("message", {
                    required: "Message is required",
                  })}
                />
                {errors.message && (
                  <span className="text-danger">{errors.message.message}</span>
                )}
              </Form.Group>
            </div>
          </div>

          <div className="form_submit_div ">
            <div className="row">
              <div className="col-lg-4 mx-auto mb-3">
                <div className="button_group">
                  <button
                    type="button"
                    className="closebtn theme_bg"
                    onClick={() => {
                      reset({ name: "" });
                      setId("");
                    }}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="addbtn"
                    onClick={handleSubmit(onSubmit)}
                  >
                    Send
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>
      <Successfull_Modal
        message={"Successful"}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default Add;
